<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row>
        <v-col cols="12" class="text-h6">
            <v-data-table :headers="headers"
                          :items="payments"
                          class="elevation-2"
                          :loading="loadingPayments"
                          :options.sync="options"
                          :expanded.sync="expandedRow"
                          :footer-props="footerProps"
                          :server-items-length="totalPayments"
                          item-key="date">
                <template v-slot:item="{ item }">
                    <tr @click="expandedRow = [item]">
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-avatar v-on="on"
                                              v-if="item.status"
                                              style="cursor: pointer;"
                                              :color="item.status === 'rejected' ? 'error' : 'success'"
                                              size="10">
                                    </v-avatar>
                                </template>

                                <span v-if="item.status">
                                    {{item.status === 'rejected' ? $tc('general.rejected', 1) : $tc('general.approved', 1)}}
                                </span>
                            </v-tooltip>
                        </td>

                        <td class="font-weight-bold">{{ item.amount }}</td>

                        <td>{{item.date | nullToDateNow | moment('DD/MM/YYYY')}}</td>

                        <td class="px-0 mx-0">
                            <div class="data-table-actions d-flex justify-center align-center">
                                <v-btn icon text>
                                    <v-icon color="kbDarkBlueText">remove_red_eye</v-icon>
                                </v-btn>
                            </div>
                        </td>
                    </tr>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                        <v-row justify="space-around" align="center">
                            <template v-if="item.payload && item.payload.gift">
                                <v-col cols="12" class="text-center my-5 error--text">
                                    <span>{{$t('general.creditCardRechargeWithOutCharge')}}</span>
                                </v-col>
                            </template>

                            <template v-else-if="item.payload && item.payload.isInvoice">
                                <v-col class="text-center text-capitalize" v-if="item.status">
                                    <span>{{$t('general.state')}}: {{ item.status }}</span>
                                </v-col>

                                <v-col>
                                    <span>{{$t('general.message')}}: {{ item.payload.description }}</span>
                                </v-col>

                                <v-col class="text-center">
                                    <span>{{$t('general.methodOf')}} {{$tc('general.payment', 1)}}</span>
                                    <span>{{$t('general.invoice')}}{{item.payload.invoice}}</span>
                                </v-col>
                            </template>

                            <template v-else-if="item.payload && item.payload.stripePayment">
                                <v-col cols="12" md="4"
                                       class="text-center text-capitalize"
                                       v-if="item.payload.stripePayment.status">
                                    <span>
                                        {{$t('general.state')}}: {{ item.payload.stripePayment.status }}
                                    </span>
                                </v-col>

                                <v-col cols="12" md="4"
                                       class="text-center"
                                       v-if="item.payload.stripePayment.outcome && item.payload.stripePayment.outcome.seller_message">
                                    <span>{{$t('general.message')}}: {{ item.payload.stripePayment.outcome.seller_message }}</span>
                                </v-col>

                                <v-col cols="12" md="4"
                                       class="text-center"
                                       v-if="item.payload.stripePayment.payment_method_details
                                            && item.payload.stripePayment.payment_method_details.card.brand
                                            && item.payload.stripePayment.payment_method_details.card.last4">
                                    <span>{{$t('general.methodOf')}} {{$tc('general.payment', 1)}} </span>
                                    <PaymentCreditCardChip  :brand="item.payload.stripePayment.payment_method_details.card.brand"
                                                            :label="item.payload.stripePayment.payment_method_details.card.brand"
                                                            :last4Digits="item.payload.stripePayment.payment_method_details.card.last4">
                                    </PaymentCreditCardChip>
                                </v-col>
                            </template>

                            <template v-else-if="item.payload && item.payload.epaycoPayment">
                                <v-col class="text-center text-capitalize" v-if="item.payload.status">
                                    <span>{{$t('general.state')}}: {{ item.payload.status }}</span>
                                </v-col>

                                <v-col>
                                    <span>{{$t('general.message')}}: {{ item.payload.epaycoPayment.data.respuesta }}</span>
                                </v-col>

                                <v-col class="text-center">
                                    <span>{{$t('general.methodOf')}} {{$tc('general.payment', 1)}}</span>
                                    <PaymentCreditCardChip :brand="item.payload.epaycoPayment.data.franquicia"
                                                           :label="item.payload.epaycoPayment.data.franquicia"
                                                           :last4Digits="'0000'">
                                    </PaymentCreditCardChip>
                                </v-col>
                                <v-col v-if="item.invoiceCharge">
                                    <span>{{$t('general.note')}} {{$t('general.billCollection')}}</span>
                                </v-col>
                            </template>

                            <template v-else>
                                <v-col class="error--text my-5 text-center">
                                    {{$t('general.noPaymentsRecords')}}
                                </v-col>
                            </template>
                        </v-row>
                    </td>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingPayments">{{$t('general.loading')}} {{$tc('general.payment', 3)}}</v-col>
                        <v-col cols="12" class="red--text text-center" v-else>{{$t('general.noPaymentsRecords')}}</v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import PaymentCreditCardChip from '@/components/ui/PaymentCreditCardChip.vue'
export default {
  components: { PaymentCreditCardChip },
  computed: {
    ...mapState({
      payments: state => state.payments.payments,
      loadingPayments: state => state.payments.loadingPayments,
      totalPayments: state => state.payments.totalPayments
    }),
    footerProps () {
      return {
        'items-per-page-text': this.$t('general.recordsPerPage'),
        'items-per-page-options': [50, 100, 200]
      }
    },
    headers () {
      return [
        { text: this.$t('general.state'), align: 'left', value: 'status' },
        { text: this.$t('general.value'), align: 'left', value: 'amount' },
        { text: this.$t('general.date'), value: 'date' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  data () {
    return {
      expandedRow: [],
      options: {}
    }
  },
  methods: {
    getPayments () {
      this.$store.commit('SET_PAGINATION_PAYMENTS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getPayments')
    }
  },
  watch: {
    options: {
      handler () {
        this.getPayments()
        this.$vuetify.goTo(0)
      },
      deep: true
    }
  }
}
</script>
